import Vue from 'vue'
import whenScrollEnds from './whenScrollEnds'
import focus from './focus'

Vue.directive('when-scroll-ends', whenScrollEnds)
Vue.directive('focus', focus)
